import { render, staticRenderFns } from "./OppositeSidebets.vue?vue&type=template&id=115b71da&scoped=true&"
import script from "./OppositeSidebets.vue?vue&type=script&lang=js&"
export * from "./OppositeSidebets.vue?vue&type=script&lang=js&"
import style0 from "./OppositeSidebets.vue?vue&type=style&index=0&id=115b71da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b71da",
  null
  
)

export default component.exports